import { render } from "./NavBarMenuDivider.vue?vue&type=template&id=1b4dd38c"
import script from "./NavBarMenuDivider.vue?vue&type=script&lang=js"
export * from "./NavBarMenuDivider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__